<template>
  <div class="container lms-wrapper-two">
    <researcher-nav />

    <div class="lms-content" @click="closeLevel2()">
      <stf-header class="filled" ref="lmsv4header" />

      <div
        class="lms-content-body"
        style="height: calc(100vh - 80px); overflow: auto"
      >
        <div
          v-if="befcr == 1"
          class="d-flex align-items-center justify-content-center ht-100p wd-100p"
        >
          <div class="card rounded-20">
            <div class="card-body">
              <div class="wd-400">
                <h3 class="tx-color-01 mg-b-5">Зар</h3>
                <p class="tx-color-03 tx-16 mg-b-40">{{ adName }}</p>

                <div class="form-group">
                  <div class="d-flex">
                    <label class="font0weight-bolder"
                      >Хүсэлт илгээж буй чиглэлээ сонгоно уу</label
                    >
                    <!-- <label class="mg-l-auto text-muted">/Монгол хэл дээр/</label> -->
                  </div>
                  <Cascader
                    :props="cscdrProps"
                    :options="locTypesCascader"
                    @change="cascaderOnChange"
                    clearable
                    :style="`width: 100%`"
                  >
                  </Cascader>
                  <!-- <input v-model="adVal" type="text" class="form-control" placeholder="Төслийн монгол нэрийг бичнэ үү"> -->
                </div>

                <button
                  @click="initAfter(0)"
                  class="btn btn-brand-02 btn-block"
                >
                  Мэдүүлгийн маягт бөглөх
                </button>
                <div class="divider-text">эсвэл</div>
                <button
                  @click="$router.go(-1)"
                  class="btn btn-outline-light btn-block"
                >
                  Буцах
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="bg-white mg-20 rounded-20 pd-20"
          v-else-if="befcr == 2 && taskRdy"
        >
          <div
            class="d-flex justify-content-between mg-b-10 bd-b bd-2 pd-b-10"
          >
            <div class="wd-50p pd-r-10">
              <Form
                v-if="fetched"
                :model="taskProfile"
                label-width="30%"
                :label-position="'left'"
                class="proffrm"
              >
                <template v-for="(f, i) in fields">
                  <FormItem
                    v-if="f.flag == 1"
                    :label="f.title"
                    :key="`lbl_${i}`"
                  >
                    <Input
                      :placeholder="f.info"
                      v-model="$data['taskProfile'][f.field]"
                    />
                  </FormItem>
                  <FormItem
                    v-else-if="f.flag == 13801"
                    :label="f.title"
                    :key="`lbl_${i}`"
                  >
                    <Input
                      :placeholder="f.info"
                      v-model="$store.state.user.userInfo.mail"
                      disabled
                    />
                    <div class="text-muted tx-11 eddt-title-info">
                      И-мэйл хаяг солих бол хэрэглэгчийн тохиргоо хэсгээс солино
                      уу
                    </div>
                  </FormItem>
                  <FormItem
                    v-else-if="f.flag == 76"
                    :label="f.title"
                    :key="`lbl_${i}`"
                  >
                    <DatePicker
                      v-model="$data['taskProfile'][f.field]"
                      placeholder="Огноо сонгоно уу"
                      type="date"
                      :format="'yyyy-MM-dd'"
                      :value-format="'yyyy-MM-dd'"
                      style="width: 100%"
                    ></DatePicker>
                  </FormItem>
                  <FormItem
                    v-else-if="f.flag == 3"
                    :label="f.title"
                    :key="`lbl_${i}`"
                  >
                    <!-- {{ f.field }} -->
                    <loc-type-cascader
                      :id.sync="$data['taskProfile'][f.field]"
                      v-model="$data['taskProfile'][f.field]"
                      :getParentType="true"
                      :checkStrictly="true"
                      :locTypekey.sync="f.key"
                    />
                  </FormItem>
                  <div v-else>{{ f.title }} {{ f.flag }}</div>
                </template>
              </Form>
            </div>
            <div class="bd-l bd-2 pd-l-10 wd-50p">
              <div class="mg-b-20" v-if="task.organizationTask != undefined">
                Та <b>{{ task.organizationTask.task }}</b
                >-д <b>{{ task.task }}</b> чиглэлээр зөвлөлд бүртгүүлэх
                хүсэлтийн материал бэлдэж байна.
              </div>
              <div class="alert alert-warning mg-b-20" role="alert">
                <h6 class="alert-heading">Санамж !</h6>
                <!-- <div v-if="adTask.taskEn!=undefined && adTask.taskEn!=''" v-html="adTask.taskEn"></div> -->
                <p class="mb-0">
                  Материал хүлээн авах сүүлийн хугацаа:
                  <b>{{
                    adTask.d2 | moment("YYYY.MM.DD-ны HH цаг mm минут")
                  }}</b>
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div>
                <div v-for="(b, i) in taskProfile.b" :key="i">
                  <div :class="`card mg-b-20 mg-lg-b-25 tourBox_${b.ot}`">
                    <div
                      class=" card-header bg-light pd-y-15 pd-x-20 d-flex align-items-center justify-content-between"
                    >
                      <h6 class="tx-uppercase tx-semibold mg-b-0">
                        {{ i + 1 }}. {{ b.nm }}
                      </h6>
                      <nav class="nav nav-with-icon tx-13 mg-l-20">
                        <a
                          v-if="b.ot != 6"
                          @click="openAdd(b)"
                          :class="`nav-link tourBox_addBtn_${b.ot}`"
                          role="button"
                        >
                          <feather
                            type="plus"
                            class="mg-r-5 ht-20-f wd-20-f"
                          ></feather
                          >Нэмэх
                        </a>
                        <!-- <template v-if="taskModel.i8<=0 && i==0">
                    <button @click="saveRealBefore" class="text-white btn btn-success mg-l-20 wd-200">Төсөл илгээх</button>
                  </template> -->
                      </nav>
                    </div>
                    <!-- card-header -->

                    <div class="card-body bx-embed-outer pos-relative pd-0">
                      <loader
                        :ref="`ldr_box_${b.id}`"
                        :box="b"
                        :prms="{ boxChooser: false }"
                        :detailSettingProp="{
                          boxSetting: {
                            listSetting: { height: 0 },
                            hideToolbar: true,
                            hideEmptyTemplate: true,
                            autoHeight: true,
                            hideFooter: true,
                          },
                        }"
                        @on-attach="showFile($event)"
                        @on-detail="showDetail"
                        @load-box="loadBoxData"
                      />
                    </div>
                    <!-- card-footer -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex wd-100p tour_saveDataBtn">
            <button @click="$router.go(-1)" class="btn btn-light">Буцах</button>
            <template v-if="taskModel.locTypeId == 346689">
              <button
                @click="saveFake"
                class="text-white btn btn-warning mg-l-auto wd-200"
              >
                Хадгалах
              </button>
              <button
                @click="saveRealBefore2"
                class="text-white btn btn-success mg-l-20 wd-200"
              >
                Материал илгээх
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div></div>

    <task-edit
      wd="55%"
      :prms.sync="taskEdit"
      labelPosition="top"
      :show.sync="taskEdit.show"
      :disablePreEditCheck="true"
      @on-task-posted="taskPosted"
      @on-edit-close="editClosed"
      @on-attach="showFile"
    ></task-edit>

    <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      propWidth="50%"
      :hideMentionUsers="true"
      @on-task-detail="showDetail"
      @on-task-delete="taskDeleted"
      @on-task-reload="taskUpdated"
      @on-task-close="taskDialogSide.id = 0"
      :detailSettingProp="{
        hideMainMenu: true,
        showMiniMenu: true,
        hideExecution: true,
        hideProcess: true,
      }"
    ></task-detail-side>

    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <div
      v-if="processSidebr"
      class="off-canvas off-canvas-overlay off-canvas-right wd-80p show"
    >
      <!-- any content goes here -->
      <a @click="processSidebr = false" role="button" class="close"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-x"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line></svg      ></a>
      <div class="pd-25 ht-100p tx-13">
        <div class="d-flex">
          <div class="wd-50p">
            <transfers :task="task" @on-transfers-loaded="transfers = $event" />
          </div>
          <div class="wd-50p ">
            <task-process
              :task="task"
              :columns="columns"
              :users="pinnedUsers"
              :transfers.sync="transfers"
              class="pd-10"
            ></task-process>
          </div>
        </div>
      </div>
    </div>
    <div v-if="processSidebr" class="backdrop"></div>
    <b-modal
      v-model="filledObj.modal"
      size="lg"
      centered
      scrollable
      title="Мэдээлэл нягтлах"
      hide-footer
    >
      <!-- {{filledObj.list}} -->
      <div class="card mg-b-20" v-for="(rb, ri) in filledObj.list" :key="ri">
        <div class="bg-gray-100 card-header pd-x-10 pd-y-5">
          {{ rb.validationInfo.name }}
        </div>
        <div class="card-body">
          <div v-html="rb.htmlInfo"></div>
          <div
            v-if="!rb.isValid"
            v-html="rb.msg"
            :class="`alert alert-${rb.validMsgColor}`"
          ></div>
        </div>
      </div>

      <!-- <div class="alert alert-warning">
        Хэрэглэгч өөрт хамааралтай мэдээллийн үнэн зөв байдлыг хариуцах бөгөөд
        мэдээллийг дутуу эсхүл зөрүүтэй оруулснаас үүдэх эрх зүйн үр дагаврыг
        бие даан өөрөө хариуцна.
      </div> -->

      
      <div class="alert alert-warning">
        <div class="tx-semibold tx-14">Санамж</div>
        <div class="custom-control custom-checkbox">
          <input v-model="zuvshuursunvv" type="checkbox" class="custom-control-input" id="customCheck1">
          <label class="custom-control-label" for="customCheck1">Системд оруулж байгаа өөрийн мэдээллийн үнэн зөв байдлыг сайн нягталсан бөгөөд  өөрийн буруугаас  дутуу, зөрүүтэй мэдээлэл оруулснаас үүдэн гарах хариуцлагыг бие даан хариуцах болно.</label>
        </div>
      </div>

      <div class="d-flex mg-t-20">
        <a
          @click="saveRealBeforeCheck()"
          role="button"
          class="btn btn-success mg-l-auto"
          >Мэдээллийг илгээх</a
        >
      </div>
    </b-modal>

    <b-modal v-model="zuvshuursunModal" centered hide-footer title="Амжилттай" no-close-on-backdrop no-close-on-esc hide-header-close>
      <div class="alert alert-warning">
        Таны мэдээллийг амжилттай хүлээн авлаа. Докторын зэрэг хамгаалуулах зөвлөлийн дүрмийн шалгуур үзүүлэлтэд заасны дагуу мэдээллийг нягтлан, хүсэлтийг шийдвэрлэх болно.  
      </div>
      <div class="d-flex mg-t-20">
        <a @click="zuvshuursunModal = false; $router.push({ name: 'dzHome' })" class="btn btn-success mg-l-auto">Ойлголоо</a>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

let driverObj = driver({
  showProgress: true,
  nextBtnText: "Дараах",
  prevBtnText: "Өмнөх",
  doneBtnText: "Дуусгах",
  
});

import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import loader from "@/components/box/loader/loader.vue";

import { request } from "@/api/all";
import { getDetailFields, getEditFields } from "@/api/taskCore";
import { getTaskPinnedUsers } from "@/api/taskInUser";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

import { hasOneOf } from "@/libs/tools";

var _ = require("lodash");
const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import {
  Notification,
  Drawer,
  Cascader,
  Form,
  FormItem,
  Input,
  DatePicker,
} from "element-ui";

export default {
  components: {
    vueCustomScrollbar,
    loader,
    Drawer,
    Cascader,
    Form,
    FormItem,
    Input,
    DatePicker,
    transfers: () => ({
      component: import("@/components/task/components/transfers"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskProcess: () => ({
      component: import("@/components/task/components/transfers/activity.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    researcherNav: () => ({
      component: import("@/views/home/apps/dz/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    stfHeader: () => ({
      component: import(
        "@/views/home/apps/stf/researcher/components/header.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),

    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskInfo: () => ({
      component: import("@/components/task/detail/ot/components/info.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      zuvshuursunvv: false,
      zuvshuursunModal: false,
      checkSaveRealBeforeClicked: false,
      filledObj: {
        list: [],
        isAllValid: false,
        modal: false,
      },
      taskProfile: {
        b: [],
      },
      locTypesCascader: [],
      cscdrProps: {
        value: "value",
        label: "label",
        children: "children",
        multiple: false,
        checkStrictly: false,
      },
      processSidebr: false,
      drawerDta: true,
      task: {
        b: [],
      },
      transfers: [],
      pinnedUsers: [],
      columns: [],
      profile: {
        b: [],
      },
      taskInfKey: 0,
      taskActiveMenu: 0,
      taskModel: {},
      taskRdy: false,
      prjId: null,
      prjOt: null,
      taskEdit: {
        id: 0,
        boxId: 0,
        show: false,
        render: false,
        objectTypeId: 0,
        projectId: 0,
        parentId: 0,
        fillAfter: {
          organizationTaskId: null,
        },
      },

      fields: [],
      fetched: false,
      taskDialogSide: {
        show: false,
        id: 0,
        boxId: 0,
        key: 0,
      },
      fileDialog: {
        show: false,
        id: 0,
      },
      befcr: 0,
      adTask: {
        d2: null,
        taskEn: null,
      },
      adName: "",
      adVal: "",
      adType: null,
      servertime: null,
    };
  },
  beforeDestroy() {
    
    driverObj.steps=[];
    //driverObj.reset();
    if (driverObj) {
      console.log("before destroy driverObj3");
    driverObj.destroy();
    console.log("after destroy driverObj3");
    }
    
    //window.removeEventListener("resize", this.getWindowHeight);
  },
  mounted() {
    this.toggleBodyClass("addClass", "dynamic-locker");
    request({
      params: { key: "dzRoutes" },
      api: { url: "Type/GetAsyncTreeDataFullname", method: "get" },
      store: this.$store,
    }).then((res) => {
      this.toggleBodyClass("removeClass", "dynamic-locker");
      if (res != false) {
        // console.log('res.data.types', res.data.types);
        this.locTypesCascader = res.data.types;
        this.build();
      }
    });
    //this.initAfter(0);

    // request({
    //     api: { method: "GET", url: "task/taskInheritedDetail" },
    //     params: { id: 3429418 },
    //     store: this.$store,
    //   }).then((res) => {
    //     this.profile = res.data.task;
    //   }
    //   );
  },
  methods: {
    build() {
      let prj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == parseInt(599, 10)
      );

      if (prj.length > 0) {
        this.prjId = prj[0].id;
        this.prjOt = prj[0].objectTypeId;
      }

      request({
        api: { method: "POST", url: "taskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 500,
          projectId: this.prjId,
          //ot: this.prjOt,
          // id: this.$route.params.tsk,
          model: {
            organizationTaskId: this.$route.params.id,
            userId: this.$store.state.user.userId,
          },
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          let rlCnt = 0;
          let _rl = this.$store.state.app.groupSettings.filter(
            (x) => x.key == "dzRequestLimit"
          );
          if (_rl.length > 0 && _rl[0].value != undefined) {
            rlCnt = parseInt(_rl[0].value, 10);
          }
          let bfcrCnt = res.data.allCount;
          let bfcrId = 0;
          if (res.data.tasks.length) {
            bfcrId = res.data.tasks[0]["id"];
          }
          // console.log('res.data.allCount', rlCnt);
          if (this.$route.params.tsk > 0) {
            request({
              api: { method: "get", url: "task/info" },
              params: { id: this.$route.params.id },
              store: this.$store,
            }).then((resi) => {
              if (res != false) {
                //console.log('resi', resi);
                this.adTask = resi.data.task;

                this.befcr = 2;
                // this.initAfter(res.data.tasks[0]['id']);
                this.initAfter(this.$route.params.tsk);
              }
            });
          } else {
            request({
              api: { method: "get", url: "task/info" },
              params: { id: this.$route.params.id },
              store: this.$store,
            }).then((resi) => {
              if (res != false) {
                if (rlCnt > 0 && rlCnt <= bfcrCnt && bfcrId > 0) {
                  this.adTask = resi.data.task;
                  this.befcr = 2;
                  this.initAfter(bfcrId);
                } else {
                  this.adTask = resi.data.task;
                  this.adName = resi.data.task.task;
                  this.befcr = 1;
                }
              }
            });

            //this.initAfter(0);
          }
          //console.log('step -1', res);
        }
      });
    },
    cascaderOnChange(e) {
      // console.log('e', e);
      if (e.length && e.length == 2) {
        let _bv = "";
        _bv = this.locTypesCascader
          .filter((x) => x.value == e[0])[0]
          .children.filter((c) => c.value == e[1])[0].label;
        _bv +=
          "/" +
          this.locTypesCascader.filter((x) => x.value == e[0])[0].label +
          "/";
        this.adVal = _bv;
        this.adType = e[1];
      } else {
        this.adVal = "";
        this.adType = null;
      }
    },
    logout() {
      this.$refs.lmsv4header.logout();
    },
    searchHandler() {
      //console.log('srch handled');
    },
    ...mapActions([
      "handleAside",
      "resetResponsiveLayoutConfig",
      "handleMainLayoutConfig",
    ]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
      //console.log(shown, this.navbarMode);
    },
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init(id) {
      request({
        // api: { method: "POST", url: "v2/learn/studentHomeData" },
        api: { method: "GET", url: "task/TaskInheritedDetail" },
        params: { id: id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.columns = res.data.columns;
          this.task = res.data.task;
          //console.log('lft', this.task.ltFields);
          // this.task.b.unshift({id: 0, nm: 'Ерөнхий мэдээлэл'});
          if (this.task.organizationTask != null) {
            if (
              this.task.organizationTask.locTypeId == 251286 ||
              this.task.organizationTask.locTypeId == 162068
            ) {
              this.task.b = this.task.b.filter(
                (x) => !hasOneOf([x.ot], [562, 563, 564, 566, 565, 662])
              );
              if (!this.task.isCompleted) {
                this.task.b = this.task.b.filter(
                  (x) => !hasOneOf([x.ot], [594])
                );
              }
            }
          }
          //console.log('this.task', this.task);
          //this.task.b=[];

          this.initProfile();
          // this.initUsers();

          //this.openTaskEdit(this.task);

          //this.initAfter(this.task.id, 561);
        }
      });
    },
    initUsers() {
      getTaskPinnedUsers({
        params: { taskId: this.task.id, page: 0, size: 20 },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.pinnedUsers = res.data.users;
        }
      });
    },
    openTaskEdit(task) {
      this.taskEdit.id = task.id;
      this.taskEdit.objectTypeId = task.objectTypeId;
      this.taskEdit.projectId = task.projectId;
      this.taskEdit.render = true;
      this.$nextTick(function() {
        this.taskEdit.show = true;
      });
    },
    openAdd(b) {
      //console.log(b);
      this.taskEdit.id = 0;
      this.taskEdit.boxId = b.id;
      this.taskEdit.objectTypeId = b.ot;
      this.taskEdit.projectId = b.projectId;
      this.taskEdit.fillAfter.organizationTaskId = this.task.id;
      //this.taskEdit.parentId = this.profile.id;
      this.taskEdit.render = true;
      this.$nextTick(function() {
        this.taskEdit.show = true;
      });
    },
    initProfile() {
      request({
        // api: { method: "POST", url: "v2/learn/studentHomeData" },
        api: { method: "GET", url: "task/TaskInheritedDetail" },
        params: { id: this.$store.state.user.userInfo.profileId },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          res.data.task.b.forEach((x) => {
            if (x.ot == 311) {
              x.ord = 10;
            } else if (x.ot == 377) {
              x.ord = 20;
              x.nm =
                "Мэргэжлийн сэтгүүлд нийтлүүлсэн эрдэм шинжилгээний өгүүлэл";
            } else if (x.ot == 150) {
              x.ord = 30;
            } else if (x.ot == 140) {
              x.nm =
                "Их сургууль, Эрдэм шижилгээ, судалгааны байгууллагад ажилласан мэдээлэл";
            } else {
              x.ord = 999;
            }
            // console.log('z', x.ot, x.nm);
          });
          // this.columns = res.data.columns;
          this.taskProfile = res.data.task;
          this.taskProfile.b = _.orderBy(
            this.taskProfile.b.filter((x) =>
              hasOneOf([x.ot], [140, 311, 316, 377, 600])
            ),
            ["ord"],
            ["asc"]
          );
          this.initFields(138);
        }
      });
    },
    initFields(ot) {
      getEditFields({ params: { objectTypeId: ot } }).then((res) => {
        if (res != false) {
          res.data.fields.forEach((x) => {
            // console.log('x', x);
            if (x.field == "email") {
              x.editOrd = 340;
              x.flag = 13801;
            }
          });
          this.fields = _.orderBy(res.data.fields, ["editOrd"], ["asc"]);
          let _decfs = [];
          _decfs.push("task");
          _decfs.push("lat");
          _decfs.push("d1");
          _decfs.push("locTypeId2");
          _decfs.push("locTypeId11");
          _decfs.push("mobile");
          _decfs.push("email");
          this.fields = this.fields.filter((x) => hasOneOf([x.field], _decfs));
          this.fetched = true;
        }
      });
    },
    taskPosted(e) {
      //console.log('taskPosted', e);
      //this.$refs[`ldr_box_${e.prms.boxId}`][0].init();
      if (e.prms.boxId > 0) {
        this.$refs[`ldr_box_${e.prms.boxId}`][0].reInit();
      } else {
        this.init(e.obj.id);
        //this.taskInfKey++;
      }
      this.editClosed();
    },
    editClosed() {
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    initAfter(id) {
      // console.log('initAfter', id);

      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: id,
          objectTypeId: this.prjOt,
          parentId: 0,
          projectId: this.prjId,
          boxId: 0,
          userId: this.$store.state.user.userInfo.userId,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.taskRdy = true;
          this.taskModel = res.data.task;
          // console.log(this.taskModel);
          // return;
          if (id == 0) {
            this.taskModel.task = this.adVal;
            this.taskModel.locTypeId = 346689; //# Материал бэлдэж буй
            this.taskModel.locTypeId1 = this.adType; //# songoson chigleliin id hadgalj bgaan daraan hereg boln
            // this.taskModel.i8= -1;
            //this.taskModel.task= this.$store.state.user.userInfo.fullName;
            this.taskModel.organizationTaskId = this.$route.params.id;
            //console.log('step 0', this.$store.state.user.userInfo.fullName);
            this.saveDta();
          } else {
            this.init(res.data.task.id);
            // console.log('step 1', res);
          }

          this.$nextTick(() => {
            driverObj.refresh();

            driverObj.setSteps( [
              {
                element: "#mainProfileBox",
                popover: {
                  title: "Заавар",
                  description:
                    "Өөрийн хувийн мэдээллийг хянаж, бүрэн бөглөнө үү.",
                  side: "left",
                  align: "start",
                },
              },
              {
                element: ".tourBox_311",
                popover: {
                  title: "Заавар",
                  description:
                    "Боловсролын болон шинжлэх ухааны докторын зэргийн мэдээллийг энд оруулна уу",
                },
              },
              {
                element: ".tourBox_140",
                popover: {
                  title: "Заавар",
                  description:
                    'Ажлын туршлага тус бүр дээр <img style="width: 70px; display: inline-block;" src="https://res.gosmart.mn/img/tour/stfzuvlul/btn_zasah.png"> дарж,  туршлагын талаар мэдээллийг гүйцээн бөглөж, <img style="width: 70px; display: inline-block;" src="https://res.gosmart.mn/img/tour/stfzuvlul/btn_save.png"> товчийг дарна уу. Энэ үйлдлийг хийснээр  таны ажлын туршлагын мэдээллийг үнэлгээнд харгалзан үзэх болохыг анхаарна уу.',
                },
              },

              {
                element: ".tourBox_addBtn_140",
                popover: {
                  description:
                    "E-Mongolia-с татагдах боломжгүй буюу, дутуу ажлын туршлага байгаа тохиолдолд нэмж бүртгэнэ үү.",
                },
              },
              {
                element: ".tourBox_377",
                popover: {
                  title: "Заавар",
                  description:
                    "Мэргэжлийн сэтгүүлд нийтлүүлсэн эрдэм шинжилгээний өгүүллийг энд оруулна уу",
                },
              },
              {
                element: ".tour_saveDataBtn",
                popover: {
                  description:
                    "Мэдээллүүдийг бүрэн оруулсны дараа хадгалах товч дарж, хүсэлтийн загварыг хадгалах боломжтой ба, Материал илгээх товч дарснаар хүсэлт илгээгдэх буюу засвар, өөрчлөлт хийх БОЛОМЖГҮЙ болох тул мэдээллээ сайтар нягтална уу. ",
                },
              },
            ]);
            //driverObj.refresh();
            //driverObj.drive();
          });
        }
      });
    },
    saveDta() {
      // console.log('saveDta step 1');
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.taskModel },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          // console.log('saveDta step 1', res.taskId);
          this.befcr = 2;
          this.init(res.taskId);
          //console.log('step 2', res);
        }
      });
    },
    showDetail(e) {
      //console.log('showDetail', e);
      this.taskDialogSide.boxId = e.boxId;
      this.taskDialogSide.id = e.id;
    },
    loadBoxData(e) {
      //console.log('loadBoxData', e);
    },
    taskDeleted() {
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
      this.editClosed();
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    taskUpdated(e) {
      this.taskDialogSide.id = 0;
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
      //console.log('taskUpdated', e);
    },
    saveFake() {
      this.profilePost();
      Notification.warning({
        title: "Мэдээлэл хадгалагдлаа",
        message: `${moment(this.adTask.d2).format(
          "yyyy.MM.DD HH:mm"
        )}-с өмнө ШУТСАН-д илгээх шаардлагатайг анхаарна уу`,
        duration: 30000,
        position: "bottom-right",
      });
    },
    profilePost() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.taskProfile },
        store: this.$store,
      }).then(() => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
      });
    },
    saveRealBefore2() {
      if(!this.checkSaveRealBeforeClicked){
        this.checkSaveRealBeforeClicked= true;
        let _rid = this.taskModel.id;
        if (_rid <= 0) {
          _rid = this.task.id;
      }

      request({
        api: {
          method: "POST",
          url: "ProjectEdu/CheckDoctorZuvlulRequestValidation",
        },
        data: {
          requestTaskId: _rid,
        },
        store: this.$store,
      }).then((res) => {
        this.checkSaveRealBeforeClicked= false;
        if (res != false) {
          this.filledObj.list = res.data.list;
          this.filledObj.isAllValid = res.data.isAllValid;
          this.filledObj.modal = true;
          // console.log(res);
          // this.saveRealBefore();
        }
        });
      }
    },
    saveRealBeforeCheck() {
      // console.log('this.zuvshuursunvv', this.zuvshuursunvv);
      if(this.zuvshuursunvv){
      //  this.saveRealBefore();
        if (this.filledObj.isAllValid) {
          this.saveRealBefore();
        } else {
          Notification.warning({
            title: "Мэдэгдэл",
            message: `Доктор хамгаалуулах зөвлөлийн дүрэмд заасан шалгуур үзүүлэлт хангаагүй тул илгээх боломжгүй байна. Та мэдээллээ дахин нягтлана уу.`,
            duration: 30000,
            position: "bottom-right",
            });
          }
      } else {
        Notification.warning({
          title: "Мэдэгдэл",
          message: `Санамжыг зөвшөөрснөөр үргэлжлүүлэх боломжтой !`,
          duration: 30000,
          position: "bottom-right",
        });
      }
    },
    saveRealBefore() {
      request({
        api: { method: "GET", url: "servertime" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.servertime = res.data.now;
          this.saveReal();
        }
      });
    },
    saveReal() {
      let errs = [];

      if (moment(this.adTask.d2).isBefore(moment(this.servertime))) {
        errs.push("Хүсэлт авах хугацаа өнгөрсөн байна");
      }

      if (errs.length > 0) {
        Notification.warning({
          title: "",
          message: `${errs[0]}`,
          duration: 30000,
          position: "bottom-right",
        });
      } else {
        this.profilePost();
        //console.log('sdfsdf', this.taskModel.id, this.task.id);
        let _rid = this.taskModel.id;
        if (_rid <= 0) {
          _rid = this.task.id;
        }
        // console.log('rid', _rid, this.task);
        request({
          api: { method: "GET", url: "Task/GetInherited" },
          params: {
            //id: this.taskModel.id, 1006 uurchlub
            id: _rid,
            objectTypeId: this.prjOt,
            parentId: 0,
            projectId: this.prjId,
            boxId: 0,
            userId: this.$store.state.user.userInfo.userId,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            let _sdta = res.data.task;
            // _sdta.i8=1;
            _sdta.locTypeId = 346690; //# ШУТсанд илгээсэн
            // console.log('this.$store.state.user.userInfo', this.$store.state.user.userInfo);
            _sdta.secondOrganizationTaskId = this.$store.state.user.userInfo.profileId;

            request({
              api: { method: "POST", url: "Task/PostInherited" },
              data: { model: _sdta },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                // name: 'stfResearcherList',
                //   params: { type: 1 },
                Notification.info({
                  title: "",
                  message: `Амжилттай илгээлээ`,
                  duration: 30000,
                  position: "bottom-right",
                });
                this.zuvshuursunModal = true;
                this.filledObj.modal = false;
                // this.$router.push({name: 'stfResearcherList', params: {type: 4 } });
                //this.$router.push({ name: "dzHome" });
              }
            });
            // this.taskRdy= true;
            // this.taskModel= res.data.task;
            // if(id==0){
            //   this.taskModel.task= this.adVal;
            //   //this.taskModel.task= this.$store.state.user.userInfo.fullName;
            //   this.taskModel.organizationTaskId= this.$route.params.id;
            //   //console.log('step 0', this.$store.state.user.userInfo.fullName);
            //   this.saveDta();
            // }else{
            //   this.init(res.data.task.id);
            //   console.log('step 1', res);
            // }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.bx-embed-outer {
  .filemgr-content-body {
    position: relative;
    .pd-x-10 {
      height: auto !important;
    }
  }
}

.proffrm {
  .el-form-item {
    margin-bottom: 5px;
  }
}
</style>
